module.exports = __webpack_public_path__ + "static/media/poultry-in-Motion.602d46b8.jpg";